import React, { useState, useEffect, useMemo } from 'react';

export default function DesignForm({ onSave, initialData, isLoading, onCancel }) {
    const defaultState = useMemo(() => ({ name: '', sizes: '' }), []);
    const [formData, setFormData] = useState(defaultState);

    useEffect(() => {
        if(initialData) {
            setFormData({
                name: initialData.name || '',
                sizes: Array.isArray(initialData.sizes) ? initialData.sizes.join(', ') : ''
            });
        } else {
            setFormData(defaultState);
        }
    }, [initialData, defaultState]);
    
    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <div>
                <label className="block text-sm font-medium text-gray-700">Nombre del Diseño</label>
                <input type="text" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} placeholder="Ej: JOHNNY BRAVO GYM RAT" required className="input-field mt-1"/>
            </div>
            <div>
                <label className="block text-sm font-medium text-gray-700">Tallas Disponibles para este Diseño</label>
                <input type="text" value={formData.sizes} onChange={e => setFormData({...formData, sizes: e.target.value})} placeholder="Ej: S, M, L, XL" required className="input-field mt-1"/>
                <p className="text-xs text-gray-500 mt-1">Separar con comas.</p>
            </div>
            <div className="flex justify-end pt-4 border-t">
                 <button type="button" onClick={onCancel} className="btn-secondary mr-3">Cancelar</button>
                 <button type="submit" disabled={isLoading} className="btn-primary">{isLoading ? "Guardando..." : "Guardar Diseño"}</button>
            </div>
        </form>
    );
}